import type { FC } from 'react';
import DeviationLink from '@wix/da-shared-react/pkg/Duperbrowse/DeviationLink';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import DeviationMediaService from '@wix/da-shared-react/pkg/utils/DeviationMediaService';

import s from './StudioNoPreviewThumb.scss';

interface Props {
  deviation: PapiDeviation;
  width?: number;
  height?: number;
}

const StudioNoPreviewThumb: FC<Props> = ({ deviation, width, height }) => {
  const { t } = useTranslation();
  const filetype = DeviationMediaService.getMediaFileType(deviation);

  return (
    <DeviationLink
      className={s['content']}
      deviation={deviation}
      canLinkToStash
      style={{
        width,
        height,
      }}
    >
      {filetype && <div className={s['extension']}>{filetype}</div>}
      {t('stash.thumbs.noPreview')}
    </DeviationLink>
  );
};
StudioNoPreviewThumb.displayName = 'StudioNoPreviewThumb';

export default StudioNoPreviewThumb;
